<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.inspection-info.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content ir-plugin-info th-plugin-info" *ngIf="!isEmptyObject(plugin.config) && showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span
            ><strong>{{ 'plugins.inspection-info.start-date' | translate }}</strong></span
          >
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ plugin?.config?.StartDate | formatDate }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span
            ><strong>{{ 'plugins.inspection-info.end-date' | translate }}</strong></span
          >
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ plugin?.config?.EndDate | formatDate }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span
            ><strong>{{ 'plugins.inspection-info.defined-duration' | translate }}</strong></span
          >
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span *ngIf="plugin?.config?.DefinedDuration || plugin?.config?.DefinedDuration === 0"
            >{{ plugin?.config?.DefinedDuration }} days</span
          >
        </p>
      </div>
    </div>
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span
            ><strong>{{ 'plugins.inspection-info.notification' | translate }} #</strong></span
          >
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ plugin?.config?.NotificationNumber }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span
            ><strong>{{ 'plugins.inspection-info.work-order' | translate }}</strong></span
          >
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ plugin?.config?.WorkOrders?.length ? plugin.config.WorkOrders.join(', ') : plugin?.config?.ServiceOrder }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span
            ><strong>{{ 'plugins.inspection-info.type-inspection' | translate }}</strong></span
          >
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ plugin?.config?.TypeInspection | inspectiontype }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
